import { HelperShelfMessage, HelperShelfTrigger } from "components/helper_shelf"
import { array, string, func, bool } from "prop-types"

export const GradeFieldLabelHeader = () => {
  return (
    <>
      <div className="d-f g-1">
        <h4 className="label">Grade field label</h4>
        <HelperShelfTrigger id="grade-field-label" type="button" />
      </div>
      <HelperShelfMessage id="grade-field-label">
        This option changes the label of the grade field — but it does not do anything special with
        promotions in People. We strongly recommend only using Grade Entering <i>after</i>{" "}
        you&apos;ve done your grade promotions.
      </HelperShelfMessage>
    </>
  )
}

export const GradeFieldLabelSelect = ({
  gradeLabelOptions,
  gradeLabel,
  onSelect,
  showHeader = true
}) => {
  return (
    <>
      {showHeader && <GradeFieldLabelHeader />}
      <select
        id="attendee_type_grade_label"
        className="select select--inline"
        name="attendee_type[grade_label]"
        value={gradeLabel}
        onChange={onSelect}
      >
        {gradeLabelOptions.map((label, idx) => (
          <option key={idx} value={label}>
            {label}
          </option>
        ))}
      </select>
    </>
  )
}

GradeFieldLabelSelect.propTypes = {
  gradeLabelOptions: array.isRequired,
  gradeLabel: string.isRequired,
  onSelect: func.isRequired,
  showHeader: bool
}
